import { IGameOptions } from '../types/game-options';
import { MapsTemp } from '../game-engine/maps-utils/map-functions-temp';

export interface INotStarted {
  type: 'GameNotStarted';
}

export interface IGameWillStart {
  type: 'StartGame';
  gameOptions?: IGameOptions;
}

// TODO(andrei): This might not be needed
export interface IInProgress {
  type: 'InProgress';
  // optional for now
  gameOptions?: IGameOptions;
}

export interface IFinished {
  type: 'Finished';
  currentMapId: MapsTemp;
  nextGame: IGameOptions | undefined;
  idLobby: number | null;
}

export type IGameState = INotStarted | IGameWillStart | IInProgress | IFinished;

export function gameNotStarted(): INotStarted {
  return {
    type: 'GameNotStarted',
  };
}

export function gameWillStart(gameOptions: IGameOptions): IGameWillStart {
  return {
    type: 'StartGame',
    gameOptions,
  };
}

export function gameInProgress(gameOptions: IGameOptions): IInProgress {
  return {
    type: 'InProgress',
    gameOptions,
  };
}

export function gameFinished(currentMapId: MapsTemp, nextGame: any | undefined, idLobby: number | null): IFinished {
  return { type: 'Finished', nextGame, currentMapId, idLobby };
}

export function isGameFinished(gameState: IGameState): gameState is IFinished {
  return gameState.type === 'Finished';
}

export function isStartGame(gameState: IGameState): gameState is IGameWillStart {
  return gameState.type === 'StartGame';
}

export function isGameInProgress(gameState: IGameState): gameState is IInProgress {
  return gameState.type === 'InProgress';
}
